import { NotificationManager } from 'react-notifications';

import { fileOpen, apiBaseUrl } from '../service/api';

export const openFile = async (fileID, file_type, fileName, download) => {
  const fileUrl = `${apiBaseUrl}/sbl-file/download/file/${file_type}/${fileID}`;

  try {
    const { data } = await fileOpen(fileID, file_type);

    let fileType = '';
    if (fileUrl.includes('.pdf')) {
      fileType = 'application/pdf';
    } else if (fileUrl.includes('.doc') || fileUrl.includes('.docx')) {
      fileType = 'application/msword';
    } else if (fileUrl.includes('.jpg')) {
      fileType = 'image/jpeg';
    } else if (fileUrl.includes('.png')) {
      fileType = 'image/png';
    }

    if (fileType == '') {
      const url = URL.createObjectURL(data);
      // window.open(url);
      //if (download) {
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName ? `${fileName}-${fileID}` : fileID;
      a.click();
      //}
      return url;
    } else {
      const file = new Blob([data], { type: fileType });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return fileURL;
    }
  } catch (ex) {
    console.log(ex);
    NotificationManager.warning('Failed to download the file', 'Warning');
  }
};

export const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};
